export const initNodeId = 'init-node-id';
export const deferNodeId = 'defer-node-id';
export const endpointNodeId = 'endpoint-node-id';
